export default "__VITE_ASSET__BHDmCLTE__"